import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import Header from './Header';

class CreateConfirmPage extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        title: PropTypes.string,
        platform: PropTypes.string,
        downloadContent: PropTypes.object,
        match: PropTypes.object,
        isLoggedIn: PropTypes.bool,
        updateMessage: PropTypes.string,
        location: PropTypes.object
    };

    render() {
        const {title, downloadContent} = this.props;

        const activeSection = (
                <div>
                    <h1>{downloadContent.title}</h1>
                    <a id="fnMobile-downloadLink" href={downloadContent.appLink} target="_blank" rel="noopener noreferrer">
                        <div className="iosButton" />
                    </a>
                </div>
            );
        
        return (
            <div className="confirm-page createAccount">
                <div className="container-fluid content-container">
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 text-center">
                                <div className="content">
                                    <Header title={title} />
                                    {activeSection}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="heroes" />
                </div>
            </div>
        );
    }
}

export default withRouter(CreateConfirmPage);
